function Header(){
    return( 
        <header className="title">
            <h1>Food4Thought</h1>
        </header>
    );
}

export default Header;